document.addEventListener('DOMContentLoaded', function () {
  // Product gallery thumbnail swap
  var mainImg = document.getElementById('MainProductImage');
  var thumbs = document.querySelectorAll('.thumb');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (mainImg) mainImg.src = thumb.getAttribute('data-full');
    });
  });

  // Quick-add forms: prevent full page reload, show simple feedback
  document.querySelectorAll('.quick-add-form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('button');
      var original = btn.textContent;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: form.querySelector('input[name="id"]').value,
          quantity: 1
        })
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          btn.textContent = 'Added ✓';
          setTimeout(function () { btn.textContent = original; }, 1500);
          // update cart count
          fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            document.querySelectorAll('.cart-count').forEach(function (el) {
              el.textContent = cart.item_count;
            });
          });
        })
        .catch(function () { window.location.href = '/cart'; });
    });
  });
});
